jQuery(function($) {
    if ($('.blog-page').length == 0) {
        return;
    }
    var activeCategories = []; // Store active category slugs globally

    function fetchPosts(categories, pageNumber) {
        var postsContainer = $('.archive__posts'); // Target posts container
        var paginationContainer = $('.pagination-container'); // Target pagination container

        $.ajax({
            url: wemake.ajax_url, // AJAX URL from PHP
            type: 'POST',
            data: {
                action: 'filter_posts', // Action hook
                categories: categories, // Array of category slugs
                post_type: 'post',
                paged: pageNumber, // Current page number
            },
            beforeSend: function() {
                postsContainer.html('<div class="spinner-loader"></div>'); // Add loading indicator
            },
            success: function(response) {
                var data = JSON.parse(response); // Parse JSON response
                postsContainer.html(data.posts); // Replace posts
                paginationContainer.html(data.pagination); // Replace pagination
            },
            error: function(xhr, status, error) {
                console.error('Error:', error);
            }
        });
    }

    // Handle category clicks for desktop
    $('.archive__categories:not(.hidden-small-reverse) .cat-item').on('click', function(e) {
        e.preventDefault();
        var categorySlug = $(this).find('a').attr('href').split('/').filter(Boolean).pop(); // Get category slug

        // Toggle active state
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            activeCategories = activeCategories.filter(slug => slug !== categorySlug); // Remove from active categories
        } else {
            $(this).addClass('active');
            activeCategories.push(categorySlug); // Add to active categories
        }

        fetchPosts(activeCategories, 1); // Fetch posts for the updated categories
    });

    // Handle checkbox changes for mobile
    $('.archive__categories input[type="checkbox"]').on('change', function() {
        $('.all-cats').removeClass('active');
        // Reset and update global activeCategories array based on selected checkboxes
        activeCategories = $('.archive__categories input[type="checkbox"]:checked').map(function() {
            return $(this).val(); // Collect selected category slugs
        }).get();

        fetchPosts(activeCategories, 1); // Fetch posts for the updated categories
    });

    // Handle reset button (all-cats)
    $('.all-cats').on('click', function(e) {
        e.preventDefault();

        $(this).addClass('active');

        // Reset global activeCategories array
        activeCategories = [];

        // Uncheck all checkboxes
        $('.archive__categories input[type="checkbox"]').prop('checked', false);

        // Remove active state from desktop category items
        $('.archive__categories:not(.hidden-small-reverse) .cat-item').removeClass('active');

        // Fetch posts for all categories
        fetchPosts([], 1);
    });

    // Handle pagination clicks
    $(document).on('click', '.pagination-container a', function(e) {
        e.preventDefault();
        var activePage = parseInt($('.pagination-container .current').text()); // Get current page number
        var pageNumber;

        if ($(this).hasClass('prev')) {
            pageNumber = activePage - 1; // Previous page
        } else if ($(this).hasClass('next')) {
            pageNumber = activePage + 1; // Next page
        } else {
            pageNumber = parseInt($(this).text()) || 1; // Specific page number
        }

        fetchPosts(activeCategories, pageNumber); // Fetch posts for the current page with active categories

        // Scroll to .archive__categories
        $('html, body').animate({
            scrollTop: $('.archive__categories').offset().top - (window.innerWidth > 767 ? 140 : -400)
        }, 20);
    });

    // On page load, fetch posts for the first page with no active categories
    fetchPosts(activeCategories, 1); // Fetch posts for all categories
});
